/**
 * @deprecated This component uses raw colours and custom chrome that pre-date
 * the @kairofocus/ui design system. Migrate call sites to the Button primitive
 * from @kairofocus/ui in a follow-up (KF-A3 tracked this deprecation).
 */
import React from 'react';
import { useTimer } from '../contexts/TimerContext.tsx';
import './StartButton.css';

const StartButton: React.FC = () => {
  const { isActive, sessionStarted, currentTab, handleStartStop, handleSkip } = useTimer();

  const getButtonColor = (type: string) => {
    switch (type) {
      case 'pomodoro':   return 'var(--kf-work)';
      case 'shortBreak': return 'var(--kf-break)';
      case 'longBreak':  return 'var(--kf-long-break)';
      default:           return 'var(--kf-work)';
    }
  };

  return (
    <div className="start-button-container">
      <button
        className="start-button"
        onClick={handleStartStop}
        style={{ backgroundColor: getButtonColor(currentTab) }}
      >
        {isActive ? 'PAUSE' : sessionStarted ? 'RESUME' : 'START'}
      </button>
      {sessionStarted && (
        <button className="skip-button" onClick={handleSkip}>
          SKIP
        </button>
      )}
    </div>
  );
};

export default StartButton;
